const style = {
  dateComponent: {
    position: 'relative',
    "@media (max-width: 767px)": {
      marginBottom: 16
    },
    '& .activeDate': {
      backgroundColor: '#2DAAF2',
      border: '1px solid #2DAAF2',
      '& .title': {
        color: 'white'
      },
      '& .day': {
        color: 'white'
      },
    },
    '&:hover .dateBtn': {
      border: '1px solid #2DAAF2',
      backgroundColor: 'rgba(46, 169, 242, 0.1)',
      '&.activeDate': {
        backgroundColor: '#2d7cc1'
      }
    }
  },
  datePickerTrigger: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    cursor: 'pointer',
    opacity: 0
  },
  dateBtn: {
    border: '1px solid lightgray',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2px 4px 2px 12px',
    transition: 'all .2s ease',
    '& .title': {
      marginBottom: 0,
      fontWeight: 400,
      color: '#2DAAF2',
      lineHeight: 1
    },
    '& .day': {
      fontWeight: 500,
      textTransform: 'uppercase',
      fontSize: '0.8em',
      color: '#2DAAF2'
    },
  },
  clearBtn: {
    zIndex: 2
  }
}
export default style;
